import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

import { priceFormatter } from "helpers/number-formatter";

import RangePin from "assets/svg/range_pin.svg";

import styles from "./styles.module.css";

const PriceIndexGraphic = ({ min, max, current, isJetFirsatListing }) => {
  const TOTAL_WIDTH = 718;
  const totalProgressValue = 2 * min + (max - min);

  const calculateWidth = (value) => (TOTAL_WIDTH / totalProgressValue) * value;

  const greenWidth = calculateWidth(min);
  const yellowWidth = Number.isFinite(calculateWidth(max - min)) ? calculateWidth(max - min) : 0;
  const redWidth = calculateWidth(min);

  const getCurrentLeft = (current) => {
    let offset = -18;

    if (current > min && current < max) {
      offset += 8;
    } else if (current > max) {
      offset -= 80;
    } else if (current === max) {
      offset += 8;
    }

    return calculateWidth(current) + offset;
  };

  const currentLeft = getCurrentLeft(current);
  const decreasePercentage = ((Math.max(0, min - current) / min) * 100).toFixed(0);

  const [priceRanceContainerMinWidth, setPriceRangeContainerMinWidth] = useState(230);

  const [poiColor, setPoiColor] = useState("#9BD491");

  const priceMinRef = useRef(null);
  const priceMaxRef = useRef(null);
  const rangePinWrapRef = useRef(null);

  useEffect(() => {
    if (current > min && current <= max) {
      setPoiColor("#FFD872");
    } else if (current > max) {
      setPoiColor("#F2946C");
    } else {
      setPoiColor("#9BD491");
    }

    if (priceMinRef.current && priceMaxRef.current) {
      const minWidth =
        priceMinRef.current.getBoundingClientRect().width + priceMaxRef.current.getBoundingClientRect().width + 10;
      setPriceRangeContainerMinWidth(minWidth);
    }
  }, [current, min, max]);

  const getRangePinWrapStyle = () => {
    const leftPosition =
      currentLeft > TOTAL_WIDTH && rangePinWrapRef.current
        ? TOTAL_WIDTH - rangePinWrapRef.current.offsetWidth
        : currentLeft;

    const flexStyle = current > max ? { flexDirection: "row-reverse" } : {};

    return {
      left: leftPosition,
      ...flexStyle,
    };
  };

  return (
    <div className={styles.wrapper}>
      <div ref={rangePinWrapRef} className={styles.rangePinWrap} style={getRangePinWrapStyle()}>
        <div className={styles.point}>
          <RangePin />
          <div className={styles.pinPoint} style={{ backgroundColor: poiColor }}></div>
        </div>
        <div className={styles.currentPriceWrapper}>
          <div className={styles.currentPrice}>{priceFormatter(current)} TL</div>
          {isJetFirsatListing && <div className={styles.currentPriceDescription}>%{decreasePercentage} Daha Ucuz</div>}
        </div>
      </div>
      <div className={styles.progressWrap}>
        <div className={styles.greenLine} style={{ width: greenWidth }}></div>
        <div className={styles.dividerPoint}></div>
        <div className={styles.rangeWrapper} style={{ width: yellowWidth }}>
          <div className={styles.yellowLine}></div>
          <div className={styles.rangeDots}>
            {[...Array(Math.max(3, Math.floor(yellowWidth / 14)))].map((_, index) => (
              <div key={index} className={styles.rangeDot}></div>
            ))}
          </div>
        </div>
        <div className={styles.dividerPoint}></div>
        <div className={styles.redLine} style={{ width: redWidth }}></div>
      </div>
      <div className={styles.priceRangeWrapper}>
        <div
          className={styles.priceRangeContainer}
          style={{ width: yellowWidth + 150, minWidth: priceRanceContainerMinWidth }}
        >
          <div className={styles.priceMin} ref={priceMinRef}>
            Min <span className={styles.price}>&nbsp;{priceFormatter(min)} TL</span>
          </div>
          <div className={styles.priceMax} ref={priceMaxRef}>
            Max <span className={styles.price}>&nbsp;{priceFormatter(max)} TL</span>
          </div>
        </div>
      </div>
    </div>
  );
};

PriceIndexGraphic.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  current: PropTypes.number,
  isJetFirsatListing: PropTypes.bool,
};

export default PriceIndexGraphic;
